import { Localization } from "@viamap/viamap2-common";
import { Trash } from "iconsax-react";
import { useContext, useState } from "react";
import { ColorBoxEditableV2 } from "src/components/ComponentUtils";
import { GlassButton } from "src/components/GlassButtons";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { setStatus, FRPContext, updateProject } from "./FRPState";




export function FRPStatusEditor(props: {
   managedWindow: ManagedWindow,
   disabled?: boolean,
}) {
   const { dispatch } = useWindowContext();
   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
   const [localStatusOptions, setLocalStatusOptions] = useState(frpState.statusOptions);



   function confirmChanges() {
      frpDispatch(setStatus(localStatusOptions));
      dispatch(closeWindow(props.managedWindow.id));
      let loadedProject = frpState.selectedProject;
      if (loadedProject) {
         loadedProject.settings.statusOptions = localStatusOptions;
         frpDispatch(updateProject(loadedProject.id, loadedProject));
      }
   }

   function handleDeleteStatus(id: string) {
      setLocalStatusOptions(prevOptions => prevOptions.filter(status => status.id !== id));
   }

   function handleAddStatus(item: typeof frpState.statusOptions[number]) {
      const existingIds = localStatusOptions.map(s => parseInt(s.id)).filter(id => !isNaN(id));
      const nextId = existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;
      const newStatus = { ...item, id: nextId.toString() };
      setLocalStatusOptions(prevOptions => [...prevOptions, newStatus]);
   }

   function handleUpdateStatus(item: typeof frpState.statusOptions[number]) {
      setLocalStatusOptions(prevOptions => prevOptions.map(el => el.id === item.id ? item : el).sort((a, b) => a.status - b.status))

   }




   return <AdvancedDragModal window={props.managedWindow} title="FRP Status Editor" onClose={() => { dispatch(closeWindow(props.managedWindow.id)) }}
      PosDefault={{ width: "400px", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
   >

      <ADModalInfo center={true}>
         {Localization.getText("statusOptions:info")}
      </ADModalInfo>
      <ADModalBody>
         <div style={{ display: "flex", flexDirection: "column", paddingLeft: "10px", gap: "2px", marginTop: "10px" }}>
            {localStatusOptions?.map((statusOpt, _index) => (
               <div key={statusOpt.id} className="GlassInputControl" style={{ display: "flex", alignItems: "center" }}>
                  <ColorBoxEditableV2
                     color={statusOpt.color}
                     onCommit={(color) => {
                        handleUpdateStatus({
                           ...statusOpt,
                           color
                        })
                     }}
                  />
                  <input disabled={props.disabled}
                     value={statusOpt.val}
                     style={{ flex: "auto" }}
                     onChange={(e) => {
                        const newStatus = e.target.value;

                        handleUpdateStatus({
                           ...statusOpt,
                           val: newStatus
                        })
                     }} />
                  <input
                     type="number"
                     min="0"
                     max="100"
                     step="1"
                     disabled={props.disabled}
                     value={statusOpt.status}
                     style={{ flex: "auto", width: "60px" }}
                     onChange={(e) => {
                        const newStatus = parseInt(e.target.value) || 0;
                        handleUpdateStatus({
                           ...statusOpt,
                           status: newStatus
                        })
                     }} />
                  <div style={{ width: "4px", height: "2px" }} />
                  {!props.disabled ? <div title={Localization.getText("Delete")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={() => {
                     handleDeleteStatus(statusOpt.id);
                  }}>
                     <Trash />
                  </div> : <></>}

               </div>
            ))}
            <div style={{ padding: "2px" }}>
               <GlassButton onClick={() => { handleAddStatus({ id: "1", val: "New Status", color: "#000000", status: 0 }) }}>{Localization.getText("Add")}</GlassButton>
            </div>
         </div>
      </ADModalBody>
      <ADModalFooter>
         {/* <GlassButtonRow> */}
         <GlassButton onClick={() => { dispatch(closeWindow(props.managedWindow.id)) }}>{Localization.getText("Cancel")}</GlassButton>
         <GlassButton disabled={props.disabled} onClick={confirmChanges}>{Localization.getText("Save")}</GlassButton>
         {/* </GlassButtonRow> */}
      </ADModalFooter>
   </AdvancedDragModal>
}